import { StateContext } from '@ngxs/store';
import { ExhibitionStateModel } from '../exhibition.state';
import { ChangePublishProperty } from '../exhibition.state.actions';

export const changePublishProperty = (ctx: StateContext<ExhibitionStateModel>, action: ChangePublishProperty) => {
    ctx.patchState({
        published: action.payload.published
    });
};
